<div class="content" [formGroup]="formGroup">
  <div class="control">
    <p class="label">Nombre del comercio</p>
    <mat-form-field appearance="fill">
      <input formControlName="displayName" matInput />
      <mat-error
        class="form-error"
        *ngIf="
          (!formGroup.controls.displayName.pristine || formGroup.controls.displayName.touched) &&
          formGroup.controls.displayName.invalid
        "
      >
        {{ getErrorMessage('displayName') }}
      </mat-error>
    </mat-form-field>
  </div>
  <div class="control">
    <p class="label">Accent Color</p>
    <div class="form-field">
      <p class="label">Color</p>
      <mat-form-field class="color-hex-input" appearance="fill">
        <input formControlName="accentColor" matInput />
      </mat-form-field>
      <input
        [value]="formGroup.controls.accentColor.value"
        (change)="colorPickerChange($event)"
        type="color"
      />
    </div>
    <div class="form-color-error" *ngIf="formGroup.controls.accentColor.invalid">
      {{ getErrorMessage('accentColor') }}
    </div>
  </div>
  <div class="control">
    <p class="label">Logo</p>
    <div
      *ngIf="imagePreview"
      class="logo-preview"
      [style]="'background-image:url(' + imagePreview + ');'"
      alt="logo-preview"
    ></div>
    <div class="upload-file">
      <label [class.upload-disabled]="loading" upload-file for="file-upload"
        >Subir una imágen</label
      >
      <input id="file-upload" type="file" (change)="readImage($event)" [disabled]="loading" />
    </div>
    <p class="image-supported">Archivos permitidos: png, jpg, jpeg. Tamaño máximo 2 MB.</p>
    <div
      class="form-color-error"
      *ngIf="formGroup.controls.logoImg.invalid && formGroup.controls.logoImg.dirty"
    >
      {{ getErrorMessage('logoImg') }}
    </div>
  </div>
  <div class="control mt">
    <button
      (click)="setCommerceConfig()"
      [disabled]="!formGroup.dirty || formGroup.invalid || loading"
      class="td-btn primary"
    >
      Guardar Cambios
    </button>
  </div>
</div>
